import React, { useContext, useEffect, useRef, useState } from 'react';
import EmployeeContext from '../utils/EmpDetails/EmployeeProvider';
import ModalNew from '../components/Modal/ModalNew';
import { apiAssignToCompany } from '../services/merpservices';
import { useGlobalContext } from './SearchBar';

const EnterpriseSolutionsPopup = ({ glid }) => {
    const employeeDetails = useContext(EmployeeContext);
    const { glusrData, setVerticalId } = useGlobalContext();
    const fullName = (glusrData["glusr_usr_firstname"] ?? "").trim() + " " + (glusrData["glusr_usr_lastname"] ?? "").trim();
    const [showModal, setShowModal] = useState(false);
    const fetchedGlid = useRef(null); // ← track last fetched glid

    const getverticalId = async (glid) => {
        try {
            const res = await apiAssignToCompany(glid, 2);
            if (res?.data?.status === 200) {
                setVerticalId(res?.data?.FK_IIL_VERTICAL_ID);
                res?.data?.FK_IIL_VERTICAL_ID === "21" && setShowModal(true);
            }
        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {
        if (glid && fetchedGlid.current !== glid) {
            fetchedGlid.current = glid;
            setShowModal(false); // reset modal on new glid
            getverticalId(glid);
        }
    }, [glid]);

    const htmldisplay = `<table><tr><td style='border:0px;font-size: 16px;'><b>This is an enterprise customer, <p style='color:red'>DO NOT PITCH OR INFORM ABOUT INDIAMART PACKAGES.</p><br>Use the script mentioned below to educate the client.</b><br><br>Dear ${fullName}, We offer customized solution for our enterprise partners. I will arrange a call back for you from one of our consultants to help address your requirement.<br><br>Raise a ticket if client is interested.</tr></td></table>`;

    return (
        <>
            <ModalNew
                glid={glid}
                show={showModal}
                header=""
                history={htmldisplay}
                onClose={() => setShowModal(false)}
                screen='es-popup'
            />
        </>
    );
};

export default EnterpriseSolutionsPopup;